import * as React from "react";
import { TimeStamp, EventText } from "..";
import { Possession } from "sb-resp-ui";
import { getValueHelper, returnValueHelper } from "../../../../helpers";
import { EventNameObj } from "../../../../data/helpers/types";

export function EventName(eventNameObj: EventNameObj, hasEventStartLiveScb: boolean) {
    let eventHasStartedLiveScb = eventNameObj.eventObj.eventHasStarted && eventNameObj.eventObj.hasLiveScb;

    return (
        <div className={"rj-superbanner__event-names-row" +
            (returnValueHelper(eventHasStartedLiveScb, " rj-superbanner__event-names-row--scoreboard", ""))}>
            {getValueHelper(eventHasStartedLiveScb && eventNameObj.eventObj.hasPossession,
                <Possession
                    onService={eventNameObj.onService}
                    modifier="superbanner" />)}
            {getValueHelper(!hasEventStartLiveScb,
                <TimeStamp
                    modifier={eventNameObj.timeStampMdf}
                    text={eventNameObj.textTimeScoreText} />)}
            <EventText
                text={eventNameObj.eventText}
                modifier={
                    returnValueHelper(eventNameObj.eventObj.eventTextMdf === "",
                        [eventNameObj.eventTextTypeMdf],
                        [eventNameObj.eventObj.eventTextMdf, eventNameObj.eventTextTypeMdf])
                } />
        </div>
    )
}